export { Thumbs } from './Thumbs';
